<template>
  <div>
    <section
      class="section auth-ui-section--has-margin-top
      auth-ui-section--is-very-narrow auth-ui--is-border-box"
    >
      <div
        class="container auth-ui-column-container"
      >
        <!-- Tab list -->
        <div class="tabs is-toggle auth-ui-tabs">
          <ul>
            <li
              v-for="tab in tabs"
              :key="tab"
              :class="{ 'is-active': selectedTab === tab}"
              @click.prevent="selectTab(tab)"
            >
              <a>{{ $t(`admin.${tab}Tab`) }}</a>
            </li>
          </ul>
        </div>
        <!-- Tab Select for narrow screens -->
        <div class="auth-ui-tab-select-container">
          <label
            for="tab-select"
            class="label"
          >
            {{ $t('admin.magicLinkShowTab') }}
          </label>
          <div class="select auth-ui-tabs-select-fit-content">
            <select
              id="tab-select"
              @change="selectTab($event)"
            >
              <option
                v-for="tab in tabs"
                :key="'select-' + tab"
                :value="tab"
              >
                {{ $t(`admin.${tab}Tab`) }}
              </option>
            </select>
          </div>
        </div>
        <!-- Tabs are injected here -->
        <v-send-one-time-links-free-text
          v-if="selectedTab === 'oneTimeLinkFreeText'"
          :dynamic-templates="templates"
          :refresh-templates="getDynamicTemplates"
          :template-refresh-ready="templatesReady"
        />
        <v-send-one-time-links-mailing-list
          v-else-if="selectedTab === 'oneTimeLinkMailingList'"
          :dynamic-templates="templates"
          :refresh-templates="getDynamicTemplates"
          :template-refresh-ready="templatesReady"
        />
      </div>
    </section>
  </div>
</template>

<script>
/* ============
     * Mail Sends
     * ============
     *
     * An admin page for sending different kinds of emails.
     */

import Request from '../../tools/Request';
import VSendOneTimeLinksFreeText from './Tabs/SendOneTimeLinksFreeText.vue';
import VSendOneTimeLinksMailingList from './Tabs/SendOneTimeLinksMailingList.vue';

export default {
  name: 'SendMagicLinks',

  components: {
    VSendOneTimeLinksFreeText,
    VSendOneTimeLinksMailingList,
  },

  data() {
    return {
      tabs: ['oneTimeLinkFreeText', 'oneTimeLinkMailingList'],
      selectedTab: 'oneTimeLinkFreeText',
      // Templates are loaded here to make them available to all tabs as soon as possible
      templates: [],
      error: '',
      hasError: false,
      templateRetrievalReady: false,
      templatesReady: false,
      refreshIconIsDisabled: true,
    };
  },

  watch: {
    /**
     * Sets the default template as the first item in the array,
     * and updates values that tell child components whether
     * templates are ready.
     */
    templateRetrievalReady(newVal) {
      if (newVal) {
        for (let i = 0; i < this.templates.length; i += 1) {
          const template = this.templates[i];

          if (template.defaultTemplate) {
            this.templates.splice(i, 1);
            this.templates.splice(0, 0, template);
            break;
          }
        }
        this.templatesReady = true;
      } else {
        this.templatesReady = false;
      }
    },
  },

  created() {
    this.hideBackgroundLogo();
    this.getDynamicTemplates();
  },

  methods: {
    /**
     * Hides the bg logo that's visible in sign in, register etc.
     * TODO change the actual stylesheet so that the logo doesn't need to be hidden via JS...
     * Or maybe not, since this the email UI will be separated into its own project.
     */
    hideBackgroundLogo() {
      const sheet = window.document.styleSheets[0];
      sheet.insertRule('.auth-ui-background-logo { display: none !important; }', sheet.cssRules.length);
    },

    /**
     * Changes the selected tab.
     */
    selectTab(tab) {
      if (tab.target) {
        this.selectedTab = tab.target.value;
      } else {
        this.selectedTab = tab;
      }
    },

    setTemplatesReady(isReady) {
      this.templateRetrievalReady = isReady;
    },

    enableRefreshIcon(isEnabled) {
      this.refreshIconIsDisabled = isEnabled;
    },

    clearError() {
      this.error = '';
      this.hasError = false;
    },

    showError(error) {
      this.error = error;
      this.hasError = true;
    },

    async getDynamicTemplates(pageToken) {
      this.enableRefreshIcon(false);
      this.setTemplatesReady(false);

      try {
        let url = `${process.env.VUE_APP_BACKEND_URL}/get_dynamic_templates`;

        if (pageToken) {
          url = `${url}?pageToken=${pageToken}`;
        } else {
          this.templates = [];
        }

        const response = await Request.submit('GET', url);
        this.templates = this.templates.concat(response.templates);

        if (response.pageToken) {
          await this.getDynamicTemplates(response.pageToken);
        } else {
          this.clearError();
          this.setTemplatesReady(true);
          this.enableRefreshIcon(true);
        }
      } catch (error) {
        this.setTemplatesReady(true);
        this.showError(error);
        this.enableRefreshIcon(true);
      }
    },
  },
};
</script>
